module.exports = __webpack_public_path__ + "static/media/sensible-portions.2328ace9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sensible-portions.png
// module id = 207
// module chunks = 0